import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { ThemeProvider } from "./contexts/ThemeContext";



import AuthFirst from "./pages/AuthFirst";
import SharedFeedback from "./pages/SharedFeedback";
import AnnualPortal from "./pages/AnnualPortal";

import About from "./pages/About";
import LegalNotice from "./pages/LegalNotice";
import QrView from "./pages/QrView";


function App() {
  return (
    <ThemeProvider>

        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<AuthFirst />} />
              {/* Les anciennes routes passent par la frontière de session enseignant */}
              <Route path="/login" element={<Navigate to="/dashboard" replace />} />
              <Route path="/register" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<AuthFirst />} />
              <Route path="/atelier" element={<AuthFirst />} />
              <Route path="/partage" element={<SharedFeedback />} />
              <Route path="/carnet" element={<AnnualPortal />} />
              <Route path="/e/:shareKey" element={<AuthFirst />} />
              {/* Page d'écoute du feedback : le payload voyage dans le
                  fragment (#), jamais envoyé au serveur, rien de stocké. */}
              <Route path="/qr" element={<QrView />} />
              <Route path="/a-propos" element={<About />} />
              <Route path="/mentions-legales" element={<LegalNotice />} />
            </Routes>

          </BrowserRouter>
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: {
                borderRadius: "12px",
                fontFamily: "DM Sans, sans-serif",
              },
            }}
          />
        </div>

    </ThemeProvider>
  );
}

export default App;
